import { isFunction, isUndefined } from '@philips-internal/oswald-ui-utils';
import { addPrefix, appendLeftZero, createMask, isNumberValid, removeDecimals, removePrefix, removeSeparator } from './numeric-utils.js';
function createNumericFormatter(factoryOptions) {
    const { currency = false, formatterOptionTypes, invalidMessage, name, validate: customValidate, validatorOptionTypes, defaultOptions, } = factoryOptions;
    function sanitizeValue(options, value) {
        if (isUndefined(value) || value === null) {
            value = '';
        }
        else {
            value = String(value);
        }
        const acceptDecimals = options.scale > 0;
        value = removePrefix(value, currency).trim();
        value = removeSeparator(value, options.thousandsSeparator);
        value = acceptDecimals ? appendLeftZero(value, options.radix) : removeDecimals(value, options.radix);
        return value;
    }
    function format(value, userOptions = {}) {
        const { masked, options } = createMask(userOptions, defaultOptions);
        if (!value && value !== 0) {
            return '';
        }
        if (typeof value === 'number') {
            masked.typedValue = options.scale <= 0 ? Math.trunc(value) : value;
        }
        else {
            masked.rawInputValue = sanitizeValue(options, value);
        }
        return addPrefix(masked.value, currency);
    }
    format.optionTypes = formatterOptionTypes;
    format.defaultOptions = defaultOptions;
    /**
     * Uses iMask to format the given string and return its number representation in case of valid number, otherwise
     * it returns undefined.
     *
     * TODO: Despite of the return type signature of this method allows string, it never returns a string. It was kept
     * this way due formatters structure currently only accepts one generic type and the format and validate methods need
     * to accept strings or number.
     *
     * @param value string that may represents a valid number
     * @param userOptions user formatter options to override default ones
     */
    function parse(value, userOptions = {}) {
        const { masked, options } = createMask(userOptions, defaultOptions);
        const sanitizedValue = sanitizeValue(options, value);
        masked.value = sanitizedValue;
        if (!masked.value || !isNumberValid(sanitizedValue, options)) {
            return;
        }
        return masked.typedValue;
    }
    function validate(value, userOptions = {}) {
        const message = invalidMessage;
        if (!value) {
            return [{ message, name, valid: true }];
        }
        const { masked, options } = createMask(userOptions, defaultOptions);
        masked.value = String(value);
        const isCustomValid = isFunction(customValidate) ? customValidate(String(value)) : true;
        const isMaskValid = Boolean(masked.isComplete && masked.doValidate({}));
        const isValueValid = isNumberValid(value, options);
        const isValid = isCustomValid && isMaskValid && isValueValid;
        return [{
                message,
                name,
                valid: isValid,
            }];
    }
    validate.optionTypes = validatorOptionTypes;
    return {
        format,
        getPattern: () => '',
        parse,
        validate,
    };
}
export default createNumericFormatter;
//# sourceMappingURL=numeric-formatter.js.map